export default __webpack_public_path__ + "static/media/account.32b70330.svg";